import React, { Fragment } from 'react'
import { AsyncTypeahead, Highlighter, Menu, MenuItem } from 'react-bootstrap-typeahead'
import './style.scss'
import freeTextResource from './free-text-resource.svg'
import { FetchRequest } from '@rails/request.js'

const Error = ({ error }) => {
  return <p className='inline-errors my-2'>{error}</p>
}

export default class SelectOrFreeTextTypeaheadInput extends React.Component {
  constructor(props) {
    super(props)

    let selectedRecord = null
    if (props.selected) {
      selectedRecord = { label: props.selected }
    }

    this.state = {
      isLoading: false,
      selectedRecord,
      options: props.inititalOptions,
      ...props
    }

    this._renderMenu = this._renderMenu.bind(this)
    this.handleNewRecord = this.handleNewRecord.bind(this)
  }

  handleNewRecord(event, text) {
    event.target.closest('.rbt-menu').classList.add('d-none')

    this.setState({ selectedRecord: { label: text } })
  }

  _renderMenu(results, menuProps, state) {
    const items = results.map((result, index) => (
      <Fragment key={result.value}>
        <MenuItem key={index} option={result} position={index}>
          <Highlighter search={state.text}>{result.label}</Highlighter>
        </MenuItem>
      </Fragment>
    ))

    return (
      <Menu {...menuProps}>
        {items}
        {this.state.allowNewRecord !== false && (
          <div onClick={event => this.handleNewRecord(event, state.text)} className='d-flex new-record-or-free-text'>
            <img src={freeTextResource} className='client-icon rounded-circle my-auto' />
            <span className='my-auto'>{this.state.newRecordText}</span>
          </div>
        )}
      </Menu>
    )
  }

  render() {
    const {
      options,
      disabled,
      selected,
      errors,
      placeholder,
      className,
      endpointUrl,
      isLoading,
      selectedRecord,
      selectedAttributeName,
      freeTextAttributeName,
      initialDisplay,
    } = this.state

    const handleOnChange = item => {
      let label = null
      if (item[0]) {
        label = item[0].label
      }

      this.setState({ selected: label, errors: null })

      const selectedRecord = options.find(item => item.label === label)

      this.setState({ selectedRecord })
    }

    return (
      <Fragment>
        <AsyncTypeahead
          placeholder={placeholder}
          id={'select-or-free-text'}
          renderMenu={this._renderMenu}
          filterBy={['label']}
          clearButton={!disabled}
          onChange={item => handleOnChange(item)}
          defaultInputValue={selected}
          className={className}
          minLength={initialDisplay ? 0 : 1}
          onFocus={event => {
            if (event.target.value == '' && initialDisplay) {
              this.setState({ isLoading: true })
              const request = new FetchRequest('GET', endpointUrl, { responseKind: 'json' })
              request.perform().then(async response => {
                if (response.ok) {
                  const data = await response.json
                  this.setState({
                    isLoading: false,
                    options: data
                  })
                }
              })
            }
          }}
          inputProps={{ autoComplete: 'typeahead-input', id: this.props.id }}
          isLoading={isLoading}
          labelKey='label'
          onSearch={query => {
            this.setState({ isLoading: true })
            this.setState({ selectedRecord: { label: query } })
            const url = `${endpointUrl}?q[name_cont]=${query}`
            const request = new FetchRequest('GET', url, { responseKind: 'json' })
            request.perform().then(async response => {
              if (response.ok) {
                const data = await response.json
                this.setState({
                  isLoading: false,
                  options: data
                })
              }
            })
          }}
          options={options}
        />
        {errors && <Error error={errors} />}
        {selectedRecord && selectedRecord.hasOwnProperty('value') && (
          <input type='hidden' value={selectedRecord.value} name={selectedAttributeName} />
        )}
        {selectedRecord && !selectedRecord.hasOwnProperty('value') && (
          <input type='hidden' name={selectedAttributeName} />
        )}
        {selectedRecord && <input type='hidden' value={selectedRecord.label} name={freeTextAttributeName} />}
      </Fragment>
    )
  }
}
